var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "footerContainer" }, [
      _c("div", { staticClass: "borderBg" }),
      _vm._v(" "),
      _c("section", [
        _c("div", { staticClass: "container" }, [
          _c("div", { staticClass: "clearfix main" }, [
            _c("div", { staticClass: "cdInfo fl clearfix" }, [
              _c("ul", { staticClass: "cduBox fl" }, [
                _c("li", { staticClass: "title clearfix" }, [
                  _c("span", { staticClass: "fl" }, [_vm._v("成都")]),
                  _vm._v(" "),
                  _c("span", { staticClass: "fr" }, [_vm._v("CHENGDU")])
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v("地址：成都市锦江区三色路38号成都传媒大厦B座2楼")
                ]),
                _vm._v(" "),
                _c("li", [_vm._v("电话：028-83106127 / 028-81135027")]),
                _vm._v(" "),
                _c("li", [_vm._v("客服QQ：3127809168 ")])
              ]),
              _vm._v(" "),
              _c("ul", { staticClass: "bjInfo fl" }, [
                _c("li", { staticClass: "title clearfix" }, [
                  _c("span", { staticClass: "fl" }, [_vm._v("北京")]),
                  _vm._v(" "),
                  _c("span", { staticClass: "fr" }, [_vm._v("BEIJING")])
                ]),
                _vm._v(" "),
                _c("li", [_vm._v("地址：中关村南大街33号北区502室")]),
                _vm._v(" "),
                _c("li", [_vm._v("电话：010-88544791")])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "fr code" }, [
              _c("img", {
                attrs: {
                  src: require("@/assets/images/news/code.jpg"),
                  alt: ""
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c("p", [
            _c("span", [
              _vm._v("网络文化经营许可证：川网文【2020】3977-821号")
            ]),
            _vm._v(" "),
            _c("span", [_vm._v("增值电信业务经营许可证：川B2-20220352")]),
            _vm._v(" "),
            _c("span", [_vm._v("艺术品经营单位备案证明：510104180005")])
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: { "margin-top": "18px" } }, [
            _c(
              "a",
              {
                attrs: {
                  href: "https://beian.miit.gov.cn/",
                  target: "_blank",
                  rel: "noopener noreferrer"
                }
              },
              [_vm._v("蜀ICP备10025017号-1")]
            ),
            _vm._v(" "),
            _c("span", [
              _vm._v(
                "Copyright © 2022 成都文化产权交易所有限公司 All Rights Reserved"
              )
            ])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-652b9611", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-652b9611","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layout/components/PublicFooter.vue
// module id = null
// module chunks = 